jQuery(document).ready(function($) {

    $('.faq_question').click(function() {

        if ($(this).parent().is('.open')) {
            $(this)
                .closest('.faq')
                .find('.faq_answer_container')
                .animate({'height': '0'}, 500);
            $(this).closest('.faq').removeClass('open');

        } else {
            var newHeight = $(this)
                .closest('.faq')
                .find('.faq_answer')
                .height() + 'px';
            $(this)
                .closest('.faq')
                .find('.faq_answer_container')
                .animate({'height': newHeight}, 500);
            $(this).closest('.faq').addClass('open');
        }

    });

});

/* NEW FAQ 2024 */

jQuery(document).ready(function($) {
    const $faqItems = $('.faq-item');

    $faqItems.each(function() {
        const $question = $(this).find('.faq-q');
        const $answer = $(this).find('.faq-a');

        $question.on('click', function() {
            $answer.slideToggle(); // Smooth opening and closing animation
            $question.toggleClass('open');
        });
    });
});
//# sourceMappingURL=faq.js.map
